/** Firestore collection keyed by the OneProof engage session id. */
export const MDL_CHALLENGES_COLLECTION = "mdlChallenges";

/**
 * Engage responses in this demo use `session_id`.
 * OneProof webhooks use `sessionID`. Prefer the webhook spelling, then the engage spelling.
 */
export function oneProofSessionIdFromEngage(payload: unknown): string | null {
  if (!payload || typeof payload !== "object") return null;
  const record = payload as Record<string, unknown>;
  const id = record.sessionID ?? record.session_id;
  return typeof id === "string" && id.trim() ? id.trim() : null;
}

export function mdlChallengeFields(input: {
  sessionId: string;
  email: string;
  name: string;
}): {
  sessionId: string;
  email: string;
  name: string;
  firstName: string;
  lastName: string;
  createdAt: string;
} {
  const name = input.name.trim();
  const parts = name.split(/\s+/).filter(Boolean);
  return {
    sessionId: input.sessionId,
    email: input.email.trim(),
    name,
    firstName: parts[0] || "",
    lastName: parts.slice(1).join(" "),
    createdAt: new Date().toISOString(),
  };
}
